import gql from 'graphql-tag';

export const mongoMaestrosRequest = gql`
query findMaestros($td: String, $first: Int, $offset: Int){
    findMaestros(td: $td, first: $first, offset: $offset) {
        _id
        modelo
        acero
        limite_dureza_inferior
        limite_dureza_superior
        unidad
        tipo_recocido
        ciclo
        temperatura1
        temperatura2
        enfriamiento1
        enfriamiento2
        enfriamientoRI
        temperatura_bano
        escurrido
        piezas_ban_h6
        piezas_ban_h5
        peso_pieza_df
        tempeartura_agua_df
    }
}`
